<template>
  <div class="parking-list">
    <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>住户姓名</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入住户姓名" v-model="table.search.name"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>手机号</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入手机号" v-model="table.search.phone"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>房屋身份</p>
          </a-col>
          <a-col>
            <a-select class="app-block" v-model="table.search.identity" placeholder="请选择房屋身份">
              <a-select-option :value="1">{{ houseIdentityText(1) }}</a-select-option>
              <a-select-option :value="2">{{ houseIdentityText(2) }}</a-select-option>
              <a-select-option :value="3">{{ houseIdentityText(3) }}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>认证状态</p>
          </a-col>
          <a-col>
            <a-select class="app-block" v-model="table.search.status" placeholder="请选择认证状态">
              <a-select-option :value="0">{{ houseCertificateStatusText(0) }}</a-select-option>
              <a-select-option :value="2">{{ houseCertificateStatusText(2) }}</a-select-option>
              <a-select-option :value="3">{{ houseCertificateStatusText(3) }}</a-select-option>
              <a-select-option :value="4">{{ houseCertificateStatusText(4) }}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>卡号</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入卡号" v-model="table.search.card_no"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-space>
          <a-button type="primary" @click="searchTable">查询</a-button>
          <a-button @click="resetSearchTable">重置</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-row class="mg-normal">
      <a-col>
        <a-space>
          <a-button type="primary" @click="newResident()">新增住户</a-button>
          <a-button type="primary" @click="openImportModal">批量导入</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data" rowKey="id"
      :pagination="table.page" @change="handlePageChange" v-viewer :scroll="{ x: 700, y: 480 }">
      <template slot="image" slot-scope="text, data">
        <img :src="data.image" width="40" height="40" style="margin:0 3px;cursor:pointer">
      </template>
      <template slot="state" slot-scope="text, data">
        <a-tag
          :color="data.audit_type === 2 ? 'red' : (data.audit_type === 3 ? null : (data.audit_type === 4 ? 'green' : 'blue'))">{{
            houseCertificateStatusText(data.audit_type) }}</a-tag>
      </template>
      <template slot="action" slot-scope="text, data">
        <a-space>
          <a-button type="link" @click="scanResident(data)" v-if="data.audit_type || data.identity !== 1">查看</a-button>
          <a-button type="link" @click="reviewResident(data)" v-else>审核</a-button>
          <a-button type="link" @click="changeFaceStatus(data)"
            v-if="data.face_status === 2 && data.community.dnk_face_switch === 1">启用人脸状态</a-button>
          <a-button type="link" @click="changeFaceStatus(data)"
            v-if="data.face_status === 1 && data.community.dnk_face_switch === 1" style="color:#fb8387">禁用人脸状态</a-button>
          <a-button type="link" @click="editResident(data)">编辑</a-button>
          <a-button type="link" @click="deleteResident(data)">删除</a-button>
          <a-button type="link" @click="handleOpenValidityModal(data)" v-if="data.card">修改卡有效期</a-button>
          <a-button type="link" @click="deleteResidentCard(data)" v-if="data.card">删除卡</a-button>
        </a-space>
      </template>
    </a-table>
    <a-drawer width="50%" :title="drawer.title" :visible="drawer.show" destroy-on-close @close="drawer.show = false">
      <resident-info :id="drawer.id" :community-id="communityId" :is-scan="drawer.isScan" :is-review="drawer.isReview"
        @confirm="residentInfoConfirm"></resident-info>
    </a-drawer>

    <!-- 下载 -->
    <a-modal :title="modal.title" :confirm-loading="modal.loading" v-model="modal.show" @ok="confirmModal"
      destroy-on-close centered>
      <a-form-model ref="modalForm" :model="modal.form" layout="vertical" :rules="modal.rules" :labelWrap="false"
        labelAlign="right" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
        <a-form-model-item label="选择楼宇：">
          <a @click="openBuildingModal">{{
            modal.form.build_name || "选择楼宇"
          }}</a>
        </a-form-model-item>
        <a-form-model-item label="下载模板：">
          <a @click="downTpl">点击下载</a>
        </a-form-model-item>
        <a-form-model-item label="上传文件：">
          <div class="a-upload">
            <input type="file" ref="import" id="imExcel" @change="handleChange" accept=".xlsx,.xls" class="upload" />
          </div>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 修改卡有效期 -->
    <a-modal :title="validityModal.title" :confirm-loading="validityModal.loading" v-model="validityModal.show"
      @ok="validityConfirmModal" destroy-on-close centered width="50%">
      <a-form-model ref="modalForm" :model="validityModal.form" layout="vertical" :rules="validityModal.rules"
        :labelWrap="false" labelAlign="right" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
        <div style="height:20px;width:100%"></div>
        <a-form-model-item label="有效期：">
          <a-range-picker v-model="validityModal.form.time" show-time valueFormat="YYYY-MM-DD HH:mm:ss"
            :defaultValue="[validityModal.form.start_time, validityModal.form.end_time]"></a-range-picker>
        </a-form-model-item>
        <div style="height:200px;width:100%"></div>
      </a-form-model>
    </a-modal>

    <!-- 选择楼宇 -->
    <a-modal :title="buildingModal.title" :confirm-loading="buildingModal.loading" v-model="buildingModal.show"
      @ok="buildingConfirmModal" destroy-on-close centered>
      <div class="form-box">
        <a-tree block-node :tree-data="tree.keyword ? tree.searchData : tree.data" :replaceFields="tree.params"
          @select="selectTreeNode" :selected-keys="tree.selectedKeys" :load-data="$houseTreeData"></a-tree>
      </div>
    </a-modal>

    <!-- 导入错误下载 -->
    <a-modal :title="failModal.title" :confirm-loading="failModal.loading" v-model="failModal.show"
      @ok="failModal.show = false" destroy-on-close centered>
      <div class="form-box">
        <a-row style="height:40px;line-height:40px;">
          <a-col :md="6">下载错误数据:</a-col>
          <a-col :md="3" @click="downFailData"><a>点击下载</a></a-col>
        </a-row>
        <div>错误信息:</div>
        <div v-for="(val, index) in failModal.failMsg" :key="index"
          style="height:40px;line-height:40px;border-bottom:1px solid rgba(0,0,0,0.1)">{{ val }}</div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import {
  houseIdentityText,
  houseCertificateStatusText
} from '@/io/dict.js';
import ResidentService from '@/io/resident.js';
import ResidentInfo from '@/views/community/ResidentInfo.vue';
import ExportJsonExcel from "js-export-excel";

export default {
  name: 'ResidentList',
  props: {
    communityId: {
      type: Number,
      default: null
    },
    id: {
      type: Number,
      default: null
    },
  },
  data() {
    let self = this;
    return {
      ownerUploadList: null,
      modal: {
        show: false,
        title: "批量导入",
        loading: false,
        rules: {},
        form: {
          community_id: null,
          build_id: null,
          build_name: "选择楼宇",
        },
      },
      validityModal: {
        show: false,
        title: "修改卡有效期",
        loading: false,
        rules: {},
        form: {
          card_no: null,
          start_time: null,
          end_time: null
        },
      },
      buildingModal: {
        show: false,
        title: "选择楼宇",
        loading: false,
        rules: {},
        form: {},
      },
      failModal: {
        show: false,
        title: "导入错误",
        loading: false,
        rules: {},
        form: {},
        failMsg: null,
        failData: null
      },
      tree: {
        selectedKeys: [],
        keyword: null,
        loading: false,
        data: [],
        searchData: [],
        params: {
          children: "children",
          title: "name",
          key: "_id",
        },
      },

      houseIdentityText,
      houseCertificateStatusText,
      table: {
        loading: false,
        search: {
          name: null,
          phone: null,
          card_no: null,
          identity: [],
          status: []
        },
        page: {
          total: 0,
          current: 1,
          pageSize: 10,
          showQuickJumper: true,
          showSizeChanger: true,
          showTotal() {
            return `共${self.table.page.total}条`;
          }
        },
        data: [],
        columns: [
          {
            title: '照片',
            width: 150,
            scopedSlots: { customRender: 'image' }
          },
          {
            title: '住户姓名',
            width: 100,
            dataIndex: 'name'
          },
          {
            title: '身份证号',
            width: 200,
            dataIndex: 'id_card'
          },
          {
            title: '手机号',
            width: 150,
            dataIndex: 'mobile'
          },
          {
            title: '房屋身份',
            width: 120,
            dataIndex: 'houseIdentityText'
          },
          {
            title: '所属房屋',
            width: 200,
            dataIndex: 'housing.full_name'
          },
          {
            title: '入住时间',
            width: 150,
            dataIndex: 'move_into_date'
          },
          {
            title: '认证状态',
            width: 150,
            scopedSlots: { customRender: 'state' },
          },
          {
            title: '卡号',
            width: 150,
            dataIndex: 'card.card_no'
          },
          {
            title: '有效期',
            width: 350,
            customRender: row => {
              return row.card ? `${row.card?.start_time}-${row.card?.end_time}` : ''
            }
          },
          {
            title: '操作',
            width: 400,
            fixed: 'right',
            scopedSlots: { customRender: 'action' },
          }
        ]
      },
      drawer: {
        id: null,
        title: null,
        show: false,
        isScan: false,
        isReview: false
      }
    }
  },
  components: {
    ResidentInfo,
  },
  watch: {
    id: {
      handler(newValue, oldValue) {
        if ((newValue || oldValue) && !this.table.loading) {
          this.searchTable();
        }
      },
      immediate: true
    },
    communityId: {
      handler(newValue, oldValue) {
        if ((newValue || oldValue) && !this.table.loading) {
          this.searchTable();
        }
      },
      immediate: true
    }
  },
  activated() {
    if (this.id || this.communityId) {
      this.initData();
    }
  },
  mounted() {
    this.initTreeData().then(() => {
      this.selectTreeNode([this.tree.data[0][this.tree.params.key]]);
    });
  },
  methods: {
    handleOpenValidityModal(data) {
      this.validityModal.form = {
        card_no: null,
        start_time: null,
        end_time: null
      }
      this.validityModal.show = true
      this.validityModal.form.card_no = data.card.card_no
      this.validityModal.form.start_time = data.card.start_time
      this.validityModal.form.end_time = data.card.end_time
      // this.validityModal.form.time = [data.card.start_time, data.card.end_time]

    },
    validityConfirmModal() {
      this.validityModal.form.start_time = this.validityModal.form.time[0]
      this.validityModal.form.end_time = this.validityModal.form.time[1]
      ResidentService.setCardValidity(this.validityModal.form).then(_ => {
        this.$message.success('修改成功')
        this.validityModal.show = false
        this.initData()
      })
    },
    // 选择树
    selectTreeNode(selectedKeys) {
      if (selectedKeys.length) {
        this.tree.selectedKeys = selectedKeys;
        this.$depthSearchTree((node) => {
          if (node[this.tree.params.key] === selectedKeys[0]) {
            this.modal.form.community_id = node.communityId;
            this.modal.form.build_id = node.id;
            this.modal.form.build_name = node.alias;
          }
        }, this.tree.data);
      }
    },
    initTreeData() {
      this.tree.loading = true;
      return this.$houseTreeData([], [0, 1]).then((res) => {
        this.tree.data = res;
        this.tree.loading = false;
      });
    },
    // 上传文件
    handleChange(e) {
      this.impExcel(e).then((res) => {
        this.ownerUploadList = [];
        if (res.length < 1) this.$message.error("数据为空，请重新上传");
        if (res[0]["所属房屋"]) {
          res.forEach((val) => {
            this.ownerUploadList.push({
              // ['姓名', ,'性别', '联系方式', '身份证', '入住时间', '所属房屋']
              name: String(val["姓名"]),
              sex: String(val["性别"]),
              mobile: String(val["联系方式"]),
              id_card: String(val["身份证"]),
              move_into_date: String(this.formatDate(val["入住时间"], "-")),
              house: String(val["所属房屋"]),
            });
          });
        } else {
          this.$message.error("文件内容不符合规则，请重新上传");
        }
      });
    },
    // 模板下载
    downTpl() {
      let dataTable = [
        {
          姓名: "赵丽颖",
          性别: "女",
          联系方式: "17192227391",
          身份证: "370503199909091919",
          入住时间: new Date(),
          所属房屋: "1单元-10F-1003",
        },
      ];
      let option = {};
      option.filename = "业主列表";
      option.datas = [
        {
          sheetData: dataTable,
          sheetName: "sheet",
          sheetHeader: [
            "姓名",
            "性别",
            "联系方式",
            "身份证",
            "入住时间",
            "所属房屋",
          ],
          sheetFilter: [
            "姓名",
            "性别",
            "联系方式",
            "身份证",
            "入住时间",
            "所属房屋",
          ],
        },
      ];
      let toExcel = new ExportJsonExcel(option);
      toExcel.saveExcel();
    },
    downFailData() {
      let dataTable = this.failModal.failData.map(val => {
        return {
          姓名: val.data.name,
          性别: val.data.sex,
          联系方式: val.data.mobile,
          身份证: val.data.id_card,
          入住时间: new Date(val.data.move_into_date),
          所属房屋: val.data.house,
          错误信息: val.msg
        }
      })
      let option = {};
      option.filename = "业主列表";
      option.datas = [
        {
          sheetData: dataTable,
          sheetName: "sheet",
          sheetHeader: [
            "姓名",
            "性别",
            "联系方式",
            "身份证",
            "入住时间",
            "所属房屋",
            "错误信息"
          ],
          sheetFilter: [
            "姓名",
            "性别",
            "联系方式",
            "身份证",
            "入住时间",
            "所属房屋",
            "错误信息"
          ],
        },
      ];
      let toExcel = new ExportJsonExcel(option);
      toExcel.saveExcel();
    },
    // 打开批量导入
    openImportModal() {
      this.modal.show = true;
    },
    // 选择楼宇
    openBuildingModal() {
      this.buildingModal.show = true;
    },

    // 批量导入提交
    confirmModal() {
      if (this.modal.form.build_id && this.modal.form.community_id) {
        // this.$beforeFormSubmit(this.$refs.modalForm, () => {
        this.modal.loading = true;
        ResidentService.import({
          import_data: this.ownerUploadList,
          community_id: this.modal.form.community_id,
          build_id: this.modal.form.build_id,
        }).then((res) => {
          if (this.ownerUploadList.length > res.success_total) {
            // 失败原因
            let failMsgList = [];
            this.failModal.failData = res.fail_msg
            res.fail_msg.forEach((val) => failMsgList.push(val.msg));
            // alert(failSsgList.join(","));
            this.modal.loading = false;
            this.failModal.failMsg = failMsgList
            this.failModal.show = true
          } else {
            // this.$afterFormSubmit('导入成功', () => {
            // this.modal.callback();
            this.modal.show = false;
            this.modal.loading = false;
            this.$message.success('导入成功')
            this.initData()
            // });
          }
        });
        // });
      } else {
        this.$message.error("请先选择楼宇");
      }
    },
    buildingConfirmModal() {
      if (this.modal.form.community_id && this.modal.form.build_id) {
        this.buildingModal.show = false;
        this.buildingModal.loading = false;
      } else {
        this.$message.error("请选择楼宇");
      }
    },

    async changeFaceStatus(data) {
      if (data.face_status === 2) {
        await ResidentService.enableFace(data.id)
        this.$message.success('启用成功')
        this.initData();

      } else {
        await ResidentService.disableFace(data.id)
        this.$message.success('禁用成功')
        this.initData();
      }
    },
    residentInfoConfirm() {
      this.$store.dispatch('isNewResident');
      this.drawer.show = false;
      this.initData();
    },
    scanResident(data) {
      this.drawer.id = data.id;
      this.drawer.isScan = true;
      this.drawer.isReview = false;
      this.drawer.title = '住户详情';
      this.drawer.show = true;
    },
    reviewResident(data) {
      this.drawer.id = data.id;
      this.drawer.isScan = false;
      this.drawer.isReview = true;
      this.drawer.title = '住户审核';
      this.drawer.show = true;
    },
    newResident() {
      this.table.page.current = 1;
      this.toPage({
        name: 'NewResident'
      });
    },
    editResident(data) {
      this.toPage({
        name: 'EditResident',
        params: {
          id: data.id
        }
      });
    },
    deleteResident(data) {
      let self = this;
      this.$confirm({
        title: '提示',
        content: '确认删除此住户？',
        onOk() {
          ResidentService.del(data.id).then(res => {
            self.initData();
          }).catch(err => { });
        }
      });
    },
    deleteResidentCard(data) {
      let self = this;
      this.$confirm({
        title: '提示',
        content: '确认删除此用户卡？',
        onOk() {
          ResidentService.delCard({ card_no: data.card.card_no }).then(res => {
            self.initData();
          }).catch(err => { });
        }
      });
    },
    toPage(params) {
      if (this.communityId) {
        params = {
          ...params,
          query: {
            community_id: this.communityId
          }
        }
      }
      this.$router.push(params);
    },
    searchTable() {
      this.table.page.current = 1;
      this.initData();
    },
    resetSearchTable() {
      this.table.search = {
        name: null,
        phone: null,
        identity: [],
        status: []
      };
      this.searchTable();
    },
    handlePageChange(page) {
      this.table.page.current = page.current;
      this.table.page.pageSize = page.pageSize;
      this.initData();
    },
    initData() {
      this.table.loading = true;
      this.$emit('total', 0);
      ResidentService.listPage(
        this.communityId,
        this.id,
        this.table.search.name,
        this.table.search.phone,
        this.table.search.card_no,
        this.table.search.identity,
        this.table.search.status,
        this.table.page.current,
        this.table.page.pageSize
      ).then(res => {
        this.table.data = res.data.map(val => {
          val.houseIdentityText = houseIdentityText(val.identity);
          val.houseCertificateStatusText = houseCertificateStatusText(val.audit_type);
          val.image = val.user_info && val.user_info.face_recognition ? val.user_info.face_recognition : require('../../../assets/images/avatar.png');
          return val;
        });
        this.table.page.total = res.meta.pagination.total;
        this.$emit('total', res.meta.pagination.total);
      }).catch(err => { }).finally(() => {
        this.table.loading = false;
      });
    }
  },
}
</script>

<style lang="less" scoped></style>